class ChartController {
    constructor() {
    }
}
export default ChartController;
